<!--NOT FOR PRODUCTION USE-->
<template>
    <div>
        <h3>Apollo Playground | DEV ONLY</h3>
        <div v-if="$apollo.queries.user.loading">Loading...</div>
        <div v-else>
            <div v-if="user">
                <h4>User: {{ user }}</h4>
                <h4>Organization: {{ user.organization }}</h4>
            </div>
        </div>
    </div>
</template>

<!--NOT FOR PRODUCTION USE-->
<script>
  /* eslint-disable no-console */

  // import {isEmptyObj} from "../assets/js/utils";
  // import { mapState } from "vuex";
  // import { store } from "../store";
  import gql from 'graphql-tag';

  export default {
    name: "ApolloPlayground",

    data() {
      return {
        // initialize apollo params
        user: null,
      }
    },

    // API CALL BEFORE ROUTE ENTER
    // computed: {
    //   ...mapState({
    //     user: state => state.session.user,
    //   })
    // },
    //
    // beforeRouteEnter(to, from, next) {
    //   store.dispatch('queryUser', null).then(
    //     () => {
    //       if (isEmptyObj(store.state.session.user)) {
    //         console.log('UNAUTHENTICATED!');
    //       } else {
    //         console.log('AUTHENTICATED!');
    //         console.log(store.state.session.user);
    //         next();  // proceed to requested route
    //       }
    //     },
    //     error => console.log(error));
    // },

    apollo: {
      // SIMPLE QUERY
      // user: gql`query {
      //     user {
      //       Id
      //       email
      //       membership
      //       active
      //       organization {
      //         name
      //         active
      //       }
      //     }
      //   }`,

      // ADVANCED QUERY
      user: {
        query: gql`query user {
          user {
            Ids
            email
            firstName
            lastName
            membership
            active
            organization {
              name
              active
              users {
                email
              }
            }
          }
        }`,
        // pollInterval: 3000, // ms
        // error(error) {
        //   this.error = JSON.stringify(error.message);
        // }
      },
    }
  }
</script>

<!--NOT FOR PRODUCTION USE-->
<style scoped>

</style>
